// Applicable Regulation options of a Basic UDI-DI
export const ApplicableRegulation = [
    { value: "MDR", text: "REGULATION (EU) 2017/745 on medical devices" },
    { value: "IVDR", text: "REGULATION (EU) 2017/746 on in vitro diagnostic medical devices" },
    { value: "MDD", text: "Council Directive 93/42/EEC on Medical devices" },
    { value: "AIMDD", text: "Council Directive 90/385/EEC - Approximation of the laws of the Member States relating to active implantable medical devices" },
    { value: "IVDD", text: "Directive 98/79/EC on in vitro diagnostic medical devices" },
    { value: "NONE", text: "None" },
    { value: "UNKNOWN", text: "Unknown" },
];
